import React from 'react'
import { Container } from 'reactstrap'
import Hero_support_tickets from './Hero_support_tickets'
import Previous_Support_Tickets from './Previous_Support_Tickets'

function Supportandtickets() {
  return (
    <Container  fluid={true} className="">
      <hr />
      <h1 style={{ fontSize: "24px", color: "#091954", fontWeight: "600" }}>Support & Tickets</h1>
      <p style={{ color: "#535353", fontSize: "14px" }}>
        2025 - Week 26
      </p>

      {/* <!-- Add your support and tickets related content here --> */}


      <Hero_support_tickets/>
       


       {/* ..................Previous_Support_Tickets............. */}
      <Previous_Support_Tickets/>





    </Container>

    
   
    
    

  )
}

export default Supportandtickets